import React from "react";
import { AiOutlineClose, AiOutlineMenu } from "react-icons/ai";
import "./HamburgerMenu.css"

const HamburgerMenu = ({ isOpen, onToggle }) => {
  return (
    <div className="hamburger-menu" onClick={onToggle}>
      {isOpen ? <AiOutlineClose size={30} /> : <AiOutlineMenu size={30} />}
    </div>
  );
};

export default HamburgerMenu;

